import { Button } from 'component/Button'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { SortButton } from 'page/catalog/SortButton/SortButton'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const MobileFilters = observer(() => {
  const demo = useDemo()
  const { stand, options, form } = demo
  const { filters } = options
  const { priceSorting } = demo.product
  const count = form.filtersCount
  const font = stand ? 14 : 11

  const onFilters = useLatestCallback(() => {
    demo.drawer = true
  })

  const onReset = useLatestCallback(() => {
    form.clear()
  })

  const icon = count ? <Space pad={[0, 8]} height={20} round primary>
    <Typo size={font} medium>
      {count}
    </Typo>
  </Space> : <Icon name="add" size={16} tertiary />

  const reset = !!count
  return <Space gap={12} opposite wrap>
    <Space wrap>
      {filters && <Button height={40} action={onFilters}>
        <Space gap={8}>
          <Typo size={font} first medium upper>
            {i18n('Filters')}
          </Typo>
          {icon}
        </Space>
      </Button>}
      {reset && <Divider height={16} />}
      {reset && <Button action={onReset}>
        <Typo size={font} first primary>
          {i18n('Reset')}
        </Typo>
      </Button>}
    </Space>
    <Space>
      {priceSorting && <SortButton />}
    </Space>
  </Space>
})
